import { stage } from './stage'
import { cdn } from './cdn'

export const environment = {
  production: false,
  cognito :{
    userPoolId : "ca-central-1_H62g016MA",
    userPoolWebClientId: "5ud7dffsrg7163g3b0q61vdncn",
    region: 'ca-central-1',
    identityPoolId: 'ca-central-1:5511f38f-9547-41bf-9f48-8958efa9119d',
    sessionToken: sessionStorage.getItem("sessionToken") || "",
    accessKeyId: sessionStorage.getItem("accessKeyId") || "",
    secretAccessKey: sessionStorage.getItem("secretAccessKey") || "",
  },
  sns: {
    url: "",
  },
  api:{
    cdn: 'https://eilhk0np3d.execute-api.ca-central-1.amazonaws.com/nova-dev',
    stage: stage,
    route: {
        createUser: "this is my dev file",
        updateUser: "",
        authenticate: "/authenticate",
        redirectLink: 'https://dev.profilnova.com', // was 'dev.profilnova.com',
        authenticateUlockUser: '',
        getUsers: "/users",
        deleteUsers: "/deleteUsers",
        changeUserLocation: "/changeUserLocation",
        getSelectedUsers: "/getSelectedUsers",
        setMaintenanceMessage: "/setMaintenanceMessage",
        getActiveMaintenanceMessage: "/getActiveMaintenanceMessage",
        setInactiveMaintenanceMessage: "/setInactiveMaintenanceMessage",
        updateMaintenanceMessage: "/updateMaintenanceMessage",
        createNewMaintenanceMessage: "/createNewMaintenanceMessage",
        isMaintenanceMessageKeyExist: "/isMaintenanceMessageKeyExist",
        getMaintenanceMessageList: "/getMaintenanceMessageList",
        getUserRoles: "/getUserRoles",
        saveUserRoles: "/saveUserRoles",
        setServerInMaintMode: "/setServerInMaintMode",
        getInManagePHP: "/getInManagePHP",
        getEventData: "/getEventData",
        checkUserEmail: "/checkUserEmail",
    }
  },
  users:{

  },
  saml:{
    microsoft: {
     muirwood:{
      clientId: '8357310a-1762-4aa1-9706-90fe131add9f',
      authority: 'https://login.microsoftonline.com/c0b50357-f018-4f60-bf08-47342010bf9b/',
      provider: 'login.microsoftonline.com/c0b50357-f018-4f60-bf08-47342010bf9b/v2.0',
      // redirectUri: 'http://localhost:4200/login',
      redirectUri: 'https://muirwood.profilnova.com/login',

      navigateToLoginRequestUrl: true,
      loginFailedRoute: '/login',
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
      scopes: ['user.read', 'openid']
     },
     nova:{
      clientId: '8357310a-1762-4aa1-9706-90fe131add9f',
      authority: 'https://login.microsoftonline.com/c0b50357-f018-4f60-bf08-47342010bf9b/',
      provider: 'login.microsoftonline.com/c0b50357-f018-4f60-bf08-47342010bf9b/v2.0',
      redirectUri: 'http://localhost:4200/login',
      navigateToLoginRequestUrl: true,
      loginFailedRoute: '/login',
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
      scopes: ['user.read', 'openid']
     },

    }
  }
}
